import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { SetWithExpiry } from "../../util/sessionManager";
import axios from 'axios';

export async function GetCustomers(){
    try{
        const response = await axios.post(
            MainAddress+"CustomerData/read_customer.php",
            {
                serial_program:GetSerialProgram(),
            }
          )
    
          console.log(response.data)
        if(response.data[0].success ){
            SetWithExpiry("customers",response.data,1000 * 3600 * 24);
            return{
success:response.data[0].success
            } 
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }


}